import Vue from "vue";
import MyTextMoney from "./my-text-money/MyTextMoney.vue";
import DragDropImage from "./drag-drop-file/DragDropImage/DragDropImage.vue";
import ZoomImage from "./zoom-image/ZoomImage.vue";
import RangeDate from "./range-date/RangeDate.vue";
import SelectDate from "./select-date/SelectDate.vue";

Vue.component("MyTextMoney", MyTextMoney);
Vue.component("DragDropImage", DragDropImage);
Vue.component("ZoomImage", ZoomImage);
Vue.component("RangeDate", RangeDate);
Vue.component("SelectDate", SelectDate);